import axios from "axios";

/**
 * 我的订单list
 */
export const getOrderTypeList = async <T>() => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/order-type-list",
  );
  return result.data;
};

/**
 * 我的订单list
 */
export const getApcOrderList = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/apc-order-list",
    params,
  );
  return result.data;
};
export const getBpcOrderList = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/bpc-order-list",
    params,
  );
  return result.data;
};
export const getPpvOrderList = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/ppv-order-list",
    params,
  );
  return result.data;
};
export const getMeetingOrderList = async <T>(params: {
  p: number;
  n: number;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/meeting-order-list",
    params,
  );
  return result.data;
};

/**
 * 获取ptp订单列表
 * @param params
 * @returns
 */
export const getPtpOrderList = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/ptp-order-list",
    params,
  );
  return result.data;
};

//https://pubadmin.dev.kxsz.net/api/pay/user-center/apc-order-list

/**
 * pod订单list
 */
export const podOrderList = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/pod-order-list",
    params,
  );
  return result.data;
};

/**
 * 全部发票
 */
export const AllInvoice = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/bill-list",
    params,
  );
  return result.data;
};

/**
 * 全部发票
 */
export const AllInvoiceStatic = async <T>(params: { p: number; n: number }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/bill-static",
    params,
  );
  return result.data;
};

/**
 * 开具证明
 */
export const openCertificate = async <T>(order_id: string) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/request-proof-of-payment",
    { order_id },
  );
  return result.data;
};

/**
 * 发票抬头-list
 * @param params
 * @returns
 */

export const TitleList = async <T>() => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/title-list",
  );
  return result.data;
};
/**
 * 新增发票抬头
 * @returns
 */
export const AddTitle = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/add-title",
    params,
  );
  return result.data;
};

/**
 * 编辑发票抬头
 * @param params
 * @returns
 */

export const EditTitle = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/edit-title",
    params,
  );
  return result.data;
};

/**
 * 删除发票抬头
 * @param params
 * @returns
 */

export const DelTitle = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/del-title",
    params,
  );
  return result.data;
};

/**
 * 发票地址-list
 * @param params
 * @returns
 */

export const AddressList = async <T>() => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/address-list",
  );
  return result.data;
};
/**
 * 新增发票地址
 * @returns
 */
export const AddAddress = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/add-address",
    params,
  );
  return result.data;
};

/**
 * 编辑发票地址
 * @param params
 * @returns
 */

export const EditAddress = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/edit-address",
    params,
  );
  return result.data;
};

/**
 * 删除发票地址
 * @param params
 * @returns
 */

export const DelAddress = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/del-address",
    params,
  );
  return result.data;
};

/**
 * 申请开票-订单list
 */
export const InvoicingOrderList = async <T>(params: {
  p: number;
  n: number;
  order_type: OrderType;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/bill-order-list",
    params,
  );
  return result.data;
};

/**
 * 申请开票
 */
export const InvoicingRequest = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/request-bill",
    params,
  );
  return result.data;
};

/**
 * 发票管理-统计
 */
export const InvoicingStatistic = async <T>() => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/statistic",
  );
  return result.data;
};

/**
 * 发票地址
 * @returns
 */
export const getInvoiceUrl = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/download-bill",
    params,
  );
  return result.data;
};

/**
 * 取消发票
 * @param params
 * @returns
 */

export const cancelInvoice = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/red-flush",
    params,
  );
  return result.data;
};

/**
 * 取消发票
 * @param params
 * @returns
 */

export const transferConfirmation = async <T>(params) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/transfer-confirmation",
    params,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
  return result.data;
};
